import _classCallCheck from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/**
 *  SqrtPolynomial.js
 *
 *  @module SqrtPolynomial
 *  @copyright 2002-2019 Kevin Lindsey
 */

import Polynomial from "./Polynomial.js";

/**
 *  SqrtPolynomial
 *
 *  @deprecated
 *  @memberof module:kld-polynomial
 */
var SqrtPolynomial = /*#__PURE__*/function (_Polynomial) {
  _inherits(SqrtPolynomial, _Polynomial);
  function SqrtPolynomial() {
    _classCallCheck(this, SqrtPolynomial);
    return _possibleConstructorReturn(this, _getPrototypeOf(SqrtPolynomial).apply(this, arguments));
  }
  _createClass(SqrtPolynomial, [{
    key: "eval",
    /**
     *  eval
     *
     *  @param {number} x
     *  @returns {number}
     */
    value: function _eval(x) {
      var TOLERANCE = 1e-7;
      var result = _superPropGet(SqrtPolynomial, "eval", this, 3)([x]);

      // NOTE: May need to change the following.  I added these to capture
      // some really small negative values that were being generated by one
      // of my Bezier arcLength functions
      if (Math.abs(result) < TOLERANCE) {
        result = 0;
      }
      if (result < 0) {
        throw new RangeError("Cannot take square root of negative number");
      }
      return Math.sqrt(result);
    }
    /**
     *  toString
     *
     *  @returns {string}
     */
  }, {
    key: "toString",
    value: function toString() {
      var result = _superPropGet(SqrtPolynomial, "toString", this, 3)([]);
      return "sqrt(" + result + ")";
    }
  }]);
  return SqrtPolynomial;
}(Polynomial);
export default SqrtPolynomial;